import { render, staticRenderFns } from "./WarnStatistics.vue?vue&type=template&id=2cc5eab6&scoped=true&"
import script from "./WarnStatistics.vue?vue&type=script&lang=js&"
export * from "./WarnStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5eab6",
  null
  
)

export default component.exports